export function filterSongList(value, songs) {
    const filteredList = songs.filter((song) => {
        if (song.number.indexOf(value) > -1 ||
            // song.latestDate.indexOf(value) > -1 ||
            song.name.toLowerCase().indexOf(value) > -1 ||
            song.book.toLowerCase().indexOf(value) > -1 ||
            (song.status === 3 && value.indexOf("recent") === 0) ||
            (song.status === 4 && value.indexOf("expire") === 0) ||
            (song.status === 2 && value.indexOf("forgot") === 0) ||
            (song.status === 1 && value.indexOf("know") === 0) ||
            (song.status === 0 && value.indexOf("never") === 0)) {
            return true;
        }
        return false;
    });
    return filteredList;
}
